import React from 'react';
import { motion } from 'framer-motion';

export default function ProvenanceDepthBar({
  depth = 7.5,
  sources = [],
  size = 'sm',
  testId,
}) {
  const pct = (depth / 10) * 100;
  const color =
    depth >= 8 ? '#0D9488' :
    depth >= 6 ? '#0EA5E9' :
    depth >= 4 ? '#D97706' : '#DC2626';

  return (
    <div
      className="inline-flex items-center gap-2"
      data-testid={testId ?? 'provenance-depth'}
      title={sources.length ? `Depth ${depth.toFixed(1)}/10 · ${sources.join(' + ')}` : undefined}
    >
      <div className={`relative bg-slate-100 rounded-full overflow-hidden ${size === 'xs' ? 'w-12 h-1' : 'w-16 h-1.5'}`}>
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="h-full rounded-full"
          style={{ backgroundColor: color }}
        />
      </div>
      <span
        className={`font-mono font-semibold tabular-nums ${size === 'xs' ? 'text-[9px]' : 'text-[10px]'}`}
        style={{ color }}
      >
        {depth.toFixed(1)}/10
      </span>
      {sources.length > 0 && (
        <span className="text-[9px] text-apex-neutral font-mono hidden sm:inline">
          {sources.join(' + ')}
        </span>
      )}
    </div>
  );
}
